module.exports = __webpack_public_path__ + "img/girl-esp.ca1bef17.jpg";